import React from 'react';
import Footer from '../component/Footer';

const Neurologist = () => {
    return (
        <>
            <div className="container">
            
                <div className="text-center my-5">
                    <h1>Neuro Surgery</h1>
                </div>

               
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            Neuro surgery involves the diagnosis, treatment, and surgical management of
                            disorders affecting the nervous system, including the brain, spinal cord, and peripheral nerves.
                        </p>
                        <p>
                            We specialize in brain surgeries, spinal surgeries, and treatments for neurological conditions such as
                            epilepsy, tumors, and nerve disorders.
                        </p>
                        <p>
                            Our team of highly skilled neurosurgeons uses advanced technology to offer minimally invasive treatments
                            and provide the best care possible for our patients.
                        </p>
                    </div>
                </div>
            </div>

          
            <Footer />
        </>
    );
}

export default Neurologist;
